import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';

export interface DealFromSignup {
    id: number;
    dealName: string;
    proFormas: Array<{
        id: number;
        name: string;
    }>;
}

interface GetDealsWithProFormasParams {
    orgId: string;
    excludeProFormaId?: number;
    dealName?: string;
    statusId?: number;
}

const getDealsWithProFormas = async ({
    orgId,
    excludeProFormaId,
    dealName,
    statusId,
}: GetDealsWithProFormasParams): Promise<DealFromSignup[]> => {
    const params: Record<string, any> = {};
    if (excludeProFormaId) params.exclude_pro_forma_id = excludeProFormaId;
    if (dealName) params.dealName = dealName;
    if (statusId !== undefined) params.statuId = statusId;

    const response = await axiosInstance.get(API_ENDPOINTS.ORGANIZATION_DEALS_WITH_PRO_FORMAS(orgId), { params });
    return response.data;
};

const useGetDealsWithProFormas = ({
    orgId,
    excludeProFormaId,
    dealName,
    statusId,
    enabled = true,
}: GetDealsWithProFormasParams & { enabled?: boolean }) => useQuery({
    queryKey: ['deals-with-pro-formas', orgId, excludeProFormaId, dealName, statusId],
    queryFn: () => getDealsWithProFormas({
        orgId, excludeProFormaId, dealName, statusId,
    }),
    enabled,
});

export default useGetDealsWithProFormas;
